import { lazy } from "react";

const ProductEditor = lazy(() => import("./ProductEditor"));


const ecommerceRoutes = [
  { path: "/product/create", element: <ProductEditor /> },
  { path: "/product/edit/:id", element: <ProductEditor /> },

 
];

export default ecommerceRoutes;
